<template>
    <div class="consultation-header">
        <div class="header-first">
            <div style="text-align:center;font-family: Microsoft YaHei;font-weight: bold;color: #272727;margin-top:15px;font-size:22px"><span>远程超声</span></div>
        </div>
        <div class="header-second">
            <div style="font-family: Microsoft YaHei;font-weight: bold;color: #4E4E4E;font-size:18px;margin-bottom:20px"><span>产品简介</span></div>
            <div style="font-family: Microsoft YaHei;font-weight: 400;color: #7D7D7D;margin-top:20p;text-indent:30px;">
                	基层医院通过远程超声工作站接入高清超声影像、超声操作手法视频和基层医生视频；通过互联网或5G网络实时传输到远程超声平台。专家通过
            </div>
            <div style="font-family: Microsoft YaHei;font-weight: 400;color: #7D7D7D;padding-top:10px">过连接该平台实时查看影像和操作手法视频，并与基层人员进行音视频沟通。超声会诊过程中，专家可以对超声图像有疑问的地方进行标注，并共享进行交流</div>
        </div>
        <div class="header-firth" style="margin-top:20px">
            <div style="font-family: Microsoft YaHei;font-weight: bold;color: #4E4E4E;font-size:18px"><span>产品框架</span></div>
            <div>
                <img src="@/assets/image/yuanchaosheng.png" alt="">
            </div>
        </div>
        <div class="header-forth">
            <div style="font-family: Microsoft YaHei;font-weight: bold;color: #4E4E4E;font-size:18px;margin-top:10px"><span>应用亮点</span></div>
            <div style="display:flex;justify-content:space-between;margin-top:20px;flex-wrap: wrap">
                <el-card style="width:48.1%;height:140px;border:2px solid #eee;background: #FFFFFF;display: flex;align-items: center">
                    <div style="display:flex;">
                        <div  >
                            <img src="@/assets/image/ctu.png" alt="" style="vertical-align:middle">
                        </div>
                        <div style="padding-left:15px;padding-top:10px">
                            <div style="font-size: 16px;font-family: Microsoft YaHei;font-weight: 400;color: #000000;"><span>兼容性</span></div>
                            <div style="font-family: Microsoft YaHei;font-weight: 400;color: #6A6A6A;font-size:14px;padding-top:5px;"><span>兼容各类支持高清影像输出的超声设备</span></div>
                        </div>
                    </div>
                </el-card>
                <el-card style="width:48.1%;height:140px;border:2px solid #eee;display: flex;align-items: center">
                            <div style="display:flex;">
                        <div style="vertical-align:middle">
                            <img src="@/assets/image/ctu1.png" alt="">
                        </div>
                        <div style="padding-left:15px;padding-top:6px">
                            <div style="font-size: 16px;font-family: Microsoft YaHei;font-weight: 400;color: #000000;"><span>高清效果</span></div>
                            <div style="font-family: Microsoft YaHei;font-weight: 400;color: #6A6A6A;font-size:14px;padding-top:5px;"><span>支持全高清视频输入和实时传输，满足诊断要求</span></div>
                        </div>
                    </div>
                </el-card>
                <el-card style="width:48.1%;height:140px;border:2px solid #eee;background: #FFFFFF;margin-top:25px;display: flex;align-items: center">
                                    <div style="display:flex;">
                        <div style="vertical-align:middle">
                            <img src="@/assets/image/ctu2.png" alt="">
                        </div>
                      <div style="padding-left:15px;padding-top:10px">
                            <div style="font-size: 16px;font-family: Microsoft YaHei;font-weight: 400;color: #000000;"><span>互动性</span></div>
                            <div style="font-family: Microsoft YaHei;font-weight: 400;color: #6A6A6A;font-size:14px;padding-top:5px;"><span>支持专家端的注释和分享，便于对基层医生指导</span></div>
                        </div>
                    </div>
                </el-card>
                <el-card style="width:48.1%;height:140px;border:2px solid #eee;margin-top:25px;display: flex;align-items: center">
                        <div style="display:flex;">
                        <div style="vertical-align:middle">
                            <img src="@/assets/image/ctu3.png" alt="">
                        </div>
                       <div style="padding-left:15px;padding-top:6px">
                            <div style="font-size: 16px;font-family: Microsoft YaHei;font-weight: 400;color: #000000;"><span>易用性</span></div>
                            <div style="font-family: Microsoft YaHei;font-weight: 400;color: #6A6A6A;font-size:14px;padding-top:5px;"><span>基层医院开机即用，避免复杂操作</span></div>
                        </div>
                    </div>
                </el-card>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        
    }
</script>

<style lang="scss">
    .consultation-header{
        width: 100%;
        padding-left: 20px;
        .header-forth{
            margin-right:70px;
        }

    }
</style>